const excludedAuthPaths = ['/login', '/logout', '/otp/login', '/otp/redirect']
const REVIEWS_PATH = '/reviews'
const DASHBOARD_PATH = '/dashboard'
// Reviewers only work on reports and the projects and events behind them
const REVIEWER_PATH_PREFIXES = [REVIEWS_PATH, '/report', '/project-details', '/event-details']

function isPathWithin(path: string, prefix: string): boolean {
  return path === prefix || path.startsWith(`${prefix}/`)
}

export default defineNuxtRouteMiddleware((_to: any, _from: any) => {
  const { isLoggedInAsContact, isReviewer } = useUserStore()

  if (!isLoggedInAsContact) {
    if (!excludedAuthPaths.some((path) => _to.path.includes(path))) return navigateTo('/login')
    return
  }

  const isReviewerPath =
    _to.path === DASHBOARD_PATH ||
    REVIEWER_PATH_PREFIXES.some((prefix) => isPathWithin(_to.path, prefix))

  if (isReviewer && !isReviewerPath) return navigateTo(DASHBOARD_PATH)
  if (!isReviewer && isPathWithin(_to.path, REVIEWS_PATH)) return navigateTo(DASHBOARD_PATH)
})
